export default function Ended() {
  return (
    <div className="container">
      <div className="card" style={{ textAlign: 'center', padding: 48 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🎯</div>
        <h1>面试已结束</h1>
        <p>感谢你的参与。评估结果会在 3-5 个工作日内通过邮件告知。</p>
        <p className="hint" style={{ marginTop: 24 }}>你可以关闭此页面。</p>
      </div>
    </div>
  );
}
